import './Presale.css'
import PresaleVideo from './presale.mp4'
import herovideo from './herovideo.mp4'
import { motion, AnimatePresence } from 'framer-motion';
import React, { useContext, useEffect, useState } from "react";
import { client } from "./client";

import { ConnectButton, useActiveAccount, useReadContract, useSendTransaction,useSendAndConfirmTransaction,useSimulateTransaction,useWaitForReceipt,TransactionButton, useDisconnect } from "thirdweb/react";
import { prepareContractCall, toWei, getContract } from "thirdweb";
import {usdtTokenContractAbi,usdtTokenContractAddress,contractABI,contractAddress} from './abi';
import { defineChain } from "thirdweb/chains";
import Web3 from 'web3';
import axios from 'axios';
import { AuthUserContext } from '../conext';
import ReferralCodeBox from './ReferralCodeBox';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Infura provider setup
const INFURA_PROJECT_ID = '0abb62bb6527456a8cb8c5f5f14c7932'; // Replace with your Infura ID
const provider = new Web3.providers.HttpProvider(
  `https://bsc-mainnet.infura.io/v3/${INFURA_PROJECT_ID}`
);
const web3 = new Web3(provider);

// Define your chain (replace with your actual chain details)
const yourChain = defineChain({
  id: 56, // Binance Smart Chain mainnet (replace with your chain ID)
  name: "Binance Smart Chain",
  rpc: "https://bsc-dataseed.binance.org/",
  nativeCurrency: {
    decimals: 18,
    name: "BNB",
    symbol: "BNB",
  },
  blockExplorers: [
    {
      name: "BscScan",
      url: "https://bscscan.com",
    },
  ],
});


const AnimatedText = () => {
  const [index, setIndex] = useState(0);
  const texts = ['BUY HACHI NOW', 'STAGE 1 PRESALE IS LIVE'];

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % texts.length);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <AnimatePresence mode="wait">
      <motion.span
        key={texts[index]}
        className="color-bluestroke"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 10 }}
        transition={{ duration: 0.3 }}
      >
        {texts[index]}
      </motion.span>
    </AnimatePresence>
  );
};

function Presale() {
  const account = useActiveAccount();
  const { disconnect } = useDisconnect()
  const [prices, setPrices] = useState({ priceUSD: null, priceBNB: null });
  const [selectedCurrency, setSelectedCurrency] = useState("USDT");
  const [amountPay, setAmountPay] = useState("");
  const [isApproving, setIsApproving] = useState(false);
  const [isBuying, setIsBuying] = useState(false);
  const [approvalSuccess, setApprovalSuccess] = useState(false);
  const {referralCode} = useContext(AuthUserContext);
  const presaleContract1 = new web3.eth.Contract(contractABI, contractAddress);
  const usdtContract1 = new web3.eth.Contract(usdtTokenContractAbi,usdtTokenContractAddress);
  const [myreferrerCode,setReferralCode]=useState(null);
  const [error,setError]=useState(null);
  const [successfulReferral,setSuccessfulReferral]=useState(false);
  const[referrerWalletAddress,setreferrerWalletAddress]=useState("0x0000000000000000000000000000000000000000");
  const notify = () => {
  toast.success(
  <div className="flex flex-col items-center text-center p-4">
    <img
      src="images/thanku.png"
      alt="Success"
      className="w-40 h-40 mb-4 "
    />
    <span className="text-lg font-semibold leading-snug">
      🎉 Congratulations! <br />
      You have successfully purchased <strong>HACHI Tokens</strong>.
    </span>
  </div>,
  {
    position: 'bottom-center',
    autoClose: 5000,
    className: 'custom-toast-center',
    bodyClassName: 'flex justify-center',
    hideProgressBar: true,
    closeOnClick: true,
    draggable: false,
  }
);


  };
  


  //DATABASE OPERATIONS

   const fetchPrices = async () => {
    try {
      // Get USD price per token (adjust decimals if needed)
      const usdPrice = await presaleContract1.methods.usdPricePerToken().call();
      const formattedUsdPrice = web3.utils.fromWei(usdPrice, 'ether');
      console.log(formattedUsdPrice);
      
      // Get BNB/USD price (from Chainlink oracle)
      const bnbUsdPrice = await presaleContract1.methods.getLatestBNBPrice().call();
      // Chainlink price feeds return 8 decimal values - convert BigInt to Number
    const formattedBnbUsdPrice = Number(bnbUsdPrice.toString()) / 10**8;
    console.log('BNB/USD Price:', formattedBnbUsdPrice);
    
    // Calculate BNB price per token (now using Numbers)
    const bnbPricePerToken = formattedUsdPrice/formattedBnbUsdPrice;
    console.log('BNB Price per Token:', bnbPricePerToken);
      
      setPrices({
        priceUSD: formattedUsdPrice,
        priceBNB: bnbPricePerToken.toFixed(8),
        bnbUsdPrice: formattedBnbUsdPrice
      });
    } catch (error) {
      console.error("Error fetching prices:", error);
      // Fallback to default prices if contract call fails
      setPrices({
        priceUSD: '0.2',
        priceBNB: '0.1',
        bnbUsdPrice: '400' // Example BNB/USD price
      });
    }
  };
  useEffect(() => {
    fetchPrices();
    
    // Refresh prices every 60 seconds
    const priceInterval = setInterval(fetchPrices, 60000);
    return () => clearInterval(priceInterval);
  }, []);
  
  // Contract addresses - replace with your actual addresses
  const PRESALE_CONTRACT_ADDRESS = contractAddress;
  const USDT_CONTRACT_ADDRESS =usdtTokenContractAddress;
  
  // Initialize contracts
  const presaleContract = getContract({
    client,
    address: contractAddress,
    abi:contractABI,
    chain:yourChain
  });
  
  const usdtContract = getContract({
    client,
    address: usdtTokenContractAddress,
    abi: usdtTokenContractAbi,
    chain:yourChain
  });

  // Conversion rates: 1 $HACHI equals the following in BNB or USDT
  const conversionRates = {
    BNB: prices.priceBNB,
    USDT: prices.priceUSD,
  };

  const handleInputChange = (e) => {
    setAmountPay(e.target.value);
  };

  // Calculate $HACHI based on selected currency
  const getHachiAmount = () => {
    return selectedCurrency ? (amountPay / conversionRates[selectedCurrency]).toFixed(2) : "0";
  };

  // Handle USDT approval
  const { mutate: approveUsdt, isLoading: isApprovingUsdt } = useSendTransaction();
  const handleApprove = async () => {
    if (!amountPay || !account) return;
    
    const usdtAmount = toWei(amountPay.toString(), 6); // USDT typically has 6 decimals

    try {
      setIsApproving(true);
      const tx = prepareContractCall({
        contract: usdtContract,
        method: "approve",
        params: [PRESALE_CONTRACT_ADDRESS, usdtAmount],
      });
      approveUsdt(tx);
      if(tx){
      setApprovalSuccess(true)};
    } catch (error) {
      console.error("Approval failed:", error);
    } finally {
      setIsApproving(false);
    }
  };

  // Handle USDT purchase
  const { mutate: buyWithUsdt, isLoading: isBuyingWithUsdt } = useSendTransaction();
  const handleBuyWithUsdt = async () => {
    if (!amountPay || !account) return;
    
    const usdtAmount = toWei(amountPay.toString(), 6); // USDT typically has 6 decimals
    var referrerWalletAddress = await FetchUserReferrer(account.address);
   if(!referrerWalletAddress){
    referrerWalletAddress="0x0000000000000000000000000000000000000000"
   }

    console.log('USDT WALA ' + referrerWalletAddress)
    try {
      setIsBuying(true);
      const tx = prepareContractCall({
        contract: presaleContract,
        method: "buyWithUSDT",
        params: [usdtAmount, referrerWalletAddress], // No referrer
      });
      
      await buyWithUsdt(tx);
      console.log(tx)
      // Reset form after successful purchase
       updateReferral(account.address,true)
      fetchSuccessfulReferral(account.address);
      notify();
      if(successfulReferral){
      fetchReferralCode(account.address);}
      setAmountPay("");
      setApprovalSuccess(false);
    } catch (error) {
      console.error("Purchase failed:", error);
    } finally {
      setIsBuying(false);
    }
  };

const { mutate: sendTx,isLoading:isBuyingWithBNB} = useSendTransaction();
const { data: receipt, isLoading: isConfirming } = useWaitForReceipt();

const handleBuyWithBnb = async () => {
  if (!amountPay || !account) return;

  try {
    setIsBuying(true);

    // 1. Prepare transaction
    const referrerWalletAddress = await FetchUserReferrer(account.address);
    const bnbAmount = toWei(amountPay.toString(), 18);

    const tx = prepareContractCall({
      contract: presaleContract,
      method: "buy",
      params: [referrerWalletAddress],
      value: bnbAmount,
    });
    sendTx(tx)

    // // 4. Only execute after confirmation
    // if (receipt.status === "success") {
    //   await updateReferral(account.address, true);
    //   await fetchSuccessfulReferral(account.address);

    //   if (successfulReferral) {
    //     await fetchReferralCode(account.address);
    //   }

    //   // Show success toast
    //   toast.success(
    //     <div className="flex items-center gap-3">
    //       <img src="images/pawpresale.png" alt="Success" className="w-10 h-10" />
    //       <span>Successfully purchased HACHI Tokens!</span>
    //     </div>,
    //     { 
    //       className: '!top-1/2 !left-1/2 !transform !-translate-x-1/2 !-translate-y-1/2',
    //       autoClose: 5000 
    //     }
    //   );

    //   setAmountPay("");
    // } else {
    //   throw new Error("Transaction failed");
    // }

  } catch (error) {
    toast.error(
      <div>
        <p>Purchase failed</p>
        <p className="text-sm">{error.shortMessage || error.message || "Please try again"}</p>
      </div>
    );
    console.error("Purchase failed:", error);
  } finally {
    setIsBuying(false);
  }
};

 const FetchUserReferrer = async (wallet) => {
  try {
    const response = await axios.get("https://www.api.hachikoai.io/api/users/getuserreferrer", {
      params: { walletAddress: wallet },
    });

    const referrer = response.data?.data?.Code || null;
    console.log(referrer)
    return referrer;
  } catch (error) {
    console.error("Failed to fetch referrer:", error);
    return null;
  }
};


   const registerUser = async (wallet, refCode = "") => {
    try {
        const response = await axios.post("https://www.api.hachikoai.io/api/users/register", {
            walletAddress: wallet,
            referralCode: refCode
        });
        
        if (response.data.message.includes("successfully")) {
            alert(response.data.message);
            
            // If user just got a referrer
            if (response.data.hasReferrer) {
                // Update UI to show they're now in referral chain
                console.log("Successfully added to referral chain");
            }
            // If new registration
            if (response.data.referralCode) {
                console.log(`Your referral code: ${response.data.referralCode}`);
            }
        } else {
            // Handle cases where referral code was invalid but can retry
            if (response.data.canRetry) {
                const newRefCode = prompt(response.data.message + "\n\nEnter a different referral code (or leave blank):");
                if (newRefCode !== null) { // User didn't click cancel
                    await registerUser(wallet, newRefCode);
                }
            } else {
                
            }
        }
    } catch (err) {
        console.error("Registration failed:", err);
        if (err.response?.data?.canRetry) {
            const newRefCode = prompt(err.response.data.message + "\n\nEnter a different referral code (or leave blank):");
            if (newRefCode !== null) {
                await registerUser(wallet, newRefCode);
            }
        } else {
            alert(err.response?.data?.message || "Registration failed");
        }
    }
};
const getchain=async (walletAddress)=>{
    const response = await axios.get(`https://www.api.hachikoai.io/api/users/referral-chain/${walletAddress}`);
      const referralChain = response.data.referralChain;
  
      // Extract wallet addresses from the referral chain
      const referrers = referralChain.map((referral) => referral.walletAddress);
      console.log(referrers[0]);
  
  }
  useEffect(()=>{
    if(account&&account.address){
    registerUser(account.address,referralCode);
    fetchSuccessfulReferral(account.address);
    if(successfulReferral){
      fetchReferralCode(account.address)
    }
  }
    console.log(referralCode);
  })
const updateReferral = async (walletAddress, successfulReferral) => {
    try {
        // Make the API call to update referral
        const response = await axios.post("https://www.api.hachikoai.io/api/users/updateRefferal", {
            walletAddress,
            successfulReferral: successfulReferral, // Ensure the key matches the backend expectation
        });

        // Handle the response (if needed)
        console.log("Referral updated successfully:", response.data);
        return response.data; // Return the response data if needed
    } catch (error) {
        console.error("Error updating referral:", error);
        throw error; // Re-throw the error if you want to handle it outside the function
    }
};
const fetchReferralCode = async (walletAddress) => {
  try {
      // Call the backend API to fetch referral code
      const response = await axios.get("https://www.api.hachikoai.io/api/users/getReferralCode", {
          params: { walletAddress }, // Pass walletAddress as a query parameter
      });
    
      // Set the referral code in state
      setReferralCode(`https://hachikoai.io/register?ref=${response.data.data.referralCode}`);
      setError(""); // Clear any previous errors
  } catch (error) {
      console.error("Error fetching referral code:", error);
      setError("Failed to fetch referral code. Please try again.");
      setReferralCode(""); // Clear referral code on error
  }
};
const fetchSuccessfulReferral = async (walletAddress) => {
    try {
        // Call the backend API to fetch successfulReferral
        const response = await axios.get("https://www.api.hachikoai.io/api/users/getSuccessfulReferral", {
            params: { walletAddress }, // Pass walletAddress as a query parameter
        });
        // Set the successfulReferral in state
        setSuccessfulReferral(response.data.data.successfulReferral);
        setError(""); // Clear any previous errors
    } catch (error) {
        console.error("Error fetching successfulReferral:", error);
        setError("Failed to fetch successfulReferral. Please try again.");
        setSuccessfulReferral(false); // Clear successfulReferral on error
    }
};
  return (
    <>
      <section className="hero_hero__P3Enl" id="buy">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="hero_text__Y_6VP d-md"
          style={{ 
              color: "transparent",
              maskImage: "linear-gradient(to right, black 85%, transparent 100%)",
              WebkitMaskImage: "linear-gradient(to right, black 85%, transparent 100%)"
          }}
        >
          <source src={herovideo} type="video/mp4" />
        </video>
        <div className="container_container__ZgtMu hero_container__Q1q1P">
          <div className="hero_box__jBjoR">
            <video
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
              className="hero_text__Y_6VP d-sm"
              style={{ color: "transparent" }}
            >
              <source src={PresaleVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>  
          <div className="box_box__OEu_A walletHome_wallet__50cjU">
            <div className="walletHome_title__uRuD1">
              <h2 className="title_title__BsuHC secondaryClass title_default__NPnH5 walletHome_titleBuy__Dslw5">
                <span className="max-w-max">
                  <span className="stars_stars__j_1mB stars_buyM__nSPTQ">
                    <img
                      alt="MOONHOP"
                      loading="lazy"
                      width={40}
                      height={46}
                      decoding="async"
                      data-nimg={1}
                      className="stars_first__Z_MNx"
                      style={{ color: "transparent" }}
                      src="images/star.webp"
                    />
                    <img
                      alt="MOONHOP"
                      loading="lazy"
                      width={40}
                      height={46}
                      decoding="async"
                      data-nimg={1}
                      className="stars_second__Onisv"
                      style={{ color: "transparent" }}
                      src="images/star.webp"
                    />
                    <img
                      alt="MOONHOP"
                      loading="lazy"
                      width={20}
                      height={23}
                      decoding="async"
                      data-nimg={1}
                      className="stars_third__VNnPz"
                      style={{ color: "transparent" }}
                      src="images/star.webp"
                    />
                  </span>
                <AnimatedText/>
                </span>
              </h2>
              <img
                alt="MOONHOP"
                loading="lazy"
                width={120}
                height={120}
                decoding="async"
                data-nimg={1}
                className="walletHome_titleCoins__nJkhT"
                style={{ color: "transparent" }}
                src="images/coins.webp"
              />
            </div>
            <div className="walletHome_stagePrices__OjP12">
              <p className="text_text__PePj0 color-black font-weight-400 text_default__0o7N9">
                <span className="text_text__PePj0 color-black font-weight-700 text_default__0o7N9">
                  1$Hachi=
                </span>{prices.priceUSD}$
              </p>
              <p className="text_text__PePj0 color-black font-weight-400 text_default__0o7N9">
                <span className="text_text__PePj0 color-black font-weight-700 text_default__0o7N9">
                  Next Stage
                </span>
                = 0.0002$
              </p>
            </div>
            <div className="walletHome_bar__rtfIO">
              <div className="walletHome_progressBar__RZtO3" style={{ width: "50%" }}>
                <div className="walletHome_progressPercent__zPi10 secondaryClass">
                  Raised 20,000$
                </div>
                <div className="walletHome_progressThumb__mkU8w">
                  <img
                    alt="MOONHOP"
                    loading="lazy"
                    width={88}
                    height={98}
                    decoding="async"
                    data-nimg={1}
                    className=""
                    style={{ color: "transparent" }}
                    src="images/pawpresale.png"
                  />
                </div>
              </div>
            </div>
            <div className="walletHome_buttons__container">
              <label htmlFor="">
                <p className="text_text__PePj0 color-black font-weight-400 text_small__evoSP">
                  Select payment currency:
                </p>
              </label>
              <div className="walletHome_buttons__wrapper">
                {/* BNB Button */}
                <button
                  className={`walletHome_currencyButton ${
                    selectedCurrency === "BNB" ? "selected" : ""
                  }`}
                  onClick={() => setSelectedCurrency("BNB")}
                >
                  <img src="images/bnblogo.png" alt="BNB" className="currency-icon" />
                  <span>BNB</span>
                </button>
                {/* USDT Button */}
                <button
                  className={`walletHome_currencyButton ${
                    selectedCurrency === "USDT" ? "selected" : ""
                  }`}
                  onClick={() => setSelectedCurrency("USDT")}
                >
                  <img src="images/usdtlogo.png" alt="USDT" className="currency-icon" />
                  <span>USDT</span>
                </button>
              </div>
            </div>
            <div className="walletHome_inputs__P7v2i">
              <div className="walletHome_topTexts__KJInN">
                <label htmlFor="">
                  <p className="text_text__PePj0 color-black font-weight-400 text_small__evoSP">
                    you pay:
                  </p>
                </label>
                <div className="walletHome_inputArea__5dZ_h">
                  <input
                    placeholder="Enter Amount"
                    translate="no"
                    type="number"
                    inputMode="decimal"
                    min={0}
                    defaultValue=""
                    value={amountPay}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="walletHome_topTexts__KJInN">
                <label htmlFor="">
                  <p className="text_text__PePj0 color-black font-weight-400 text_small__evoSP">
                    $Hachi you get:
                  </p>
                </label>
                <div className="walletHome_inputArea__5dZ_h">
                  <input translate="no" type="text" disabled value={getHachiAmount()} />
                  <img
                    alt="MOONHOP"
                    loading="lazy"
                    width={32}
                    height={31}
                    decoding="async"
                    data-nimg={1}
                    className=""
                    style={{ color: "transparent" }}
                    src="images/hero1.png"
                  />
                </div>
              </div>
            </div>
            

    {
      !account ? (
                <ConnectButton client={client} />
              ) :
    selectedCurrency==='USDT'?(<>
    {approvalSuccess?
    ( 
      <>
    <TransactionButton
      transaction={async() => {
        const usdtAmount = toWei(amountPay.toString(), 6); // USDT typically has 6 decimals
        // Create a transaction object and return it
        var referrerWalletAddress = await FetchUserReferrer(account.address);
   if(!referrerWalletAddress){
    referrerWalletAddress="0x0000000000000000000000000000000000000000"
   }
       const tx = prepareContractCall({
        contract: presaleContract,
        method: "buyWithUSDT",
        params: [usdtAmount, referrerWalletAddress], // No referrer
      });
        return tx;
      }}
      onTransactionSent={(result) => {
        console.log("Transaction submitted", result.transactionHash);
       updateReferral(account.address,true)
      fetchSuccessfulReferral(account.address);
      notify();
      if(successfulReferral){
      fetchReferralCode(account.address);}
      setAmountPay("");
      setApprovalSuccess(false);

      }}
      onTransactionConfirmed={(receipt) => {
        console.log("Transaction confirmed", receipt.transactionHash);
       
      }}
      onError={(error) => {
        console.error("Transaction error", error);
      }}
    >
      Buy With USDT
    </TransactionButton>
    <ConnectButton client={client}></ConnectButton></>
  ):(<><TransactionButton
      transaction={() => {
        const usdtAmount = toWei(amountPay.toString(), 6); // USDT typically has 6 decimals
        // Create a transaction object and return it
       const tx = prepareContractCall({
        contract: usdtContract,
        method: "approve",
        params: [PRESALE_CONTRACT_ADDRESS, usdtAmount],
      });
        return tx;
      }}
      onTransactionSent={(result) => {
        console.log("Transaction submitted", result.transactionHash);
      }}
      onTransactionConfirmed={(receipt) => {
        console.log("Transaction confirmed", receipt.transactionHash);
        setApprovalSuccess(true);
      }}
      onError={(error) => {
        console.error("Transaction error", error);
      }}
    >
      Approve USDT
    </TransactionButton>
  <ConnectButton client={client}></ConnectButton></>
  )}
    </>):selectedCurrency==="BNB"?(<>
     <TransactionButton
      transaction={async() => {
        const bnbAmount = toWei(amountPay.toString(), 18); // USDT typically has 6 decimals
        // Create a transaction object and return it
        var referrerWalletAddress = await FetchUserReferrer(account.address);
   if(!referrerWalletAddress){
    referrerWalletAddress="0x0000000000000000000000000000000000000000"
   }
  

    const tx = prepareContractCall({
      contract: presaleContract,
      method: "buy",
      params: [referrerWalletAddress],
      value: bnbAmount,
    });
    sendTx(tx)
        return tx;
      }}
      onTransactionSent={(result) => {
        console.log("Transaction submitted", result.transactionHash);
       updateReferral(account.address,true)
      fetchSuccessfulReferral(account.address);
      notify();
      if(successfulReferral){
      fetchReferralCode(account.address);}
      setAmountPay("");
      setApprovalSuccess(false);

      }}
      onTransactionConfirmed={(receipt) => {
        console.log("Transaction confirmed", receipt.transactionHash);
       
      }}
      onError={(error) => {
        console.error("Transaction error", error);
      }}
    >
      Buy With BNB
    </TransactionButton><ConnectButton client={client}></ConnectButton>
    </>):(<></>)}
    
    
          </div>
        </div>
       
        <img
          alt="MOONHOP"
          fetchpriority="high"
          width={511}
          height={517}
          decoding="async"
          data-nimg={1}
          className="hero_heroImg__Deb6J"
          style={{ color: "transparent" }}
          src="images/hero1.png"
        />
      </section>
      <ReferralCodeBox referralCode={myreferrerCode} /> 
    </>
  )
}

export default Presale;